// @flow

import type { Action } from "redux-action";
import type { NotificationsState } from "./types";

export const setLoading = (state: NotificationsState) => () => ({
  ...state,
  requestsInProgress: ++state.requestsInProgress,
});

export const onGetMyNotificationsSuccess = (state: NotificationsState) => ({ payload }: Object) => {
  return {
    ...state,
    myNotifications: payload,
    error: null,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  };
};

export const onGetMyNotificationsError = (state: NotificationsState) => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  };
};

export const onGetEmployeeAbsenceNotificationSuccess = (state: NotificationsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    myNotifications: {
      ...state.myNotifications,
      content: state.myNotifications.content.map(item =>
        item.id === payload.id ? { ...item, content: payload.content } : item,
      ),
    },
  };
};

type onSetMyNotificationsSearchPayload = {
  notificationsSearch: string,
};
export const onSetMyNotificationsSearch = (state: NotificationsState) => (
  action: Action<onSetMyNotificationsSearchPayload>,
) => {
  const { notificationsSearch } = action.payload || {};

  return {
    ...state,
    notificationsSearch,
  };
};
